<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动流水</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="日期" prop="title">
            <el-date-picker
              v-model="queryParams.time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="用户ID" prop="uid">
            <el-input
              v-model="queryParams.uid"
              placeholder="请输入用户ID"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="活动分类" prop="create">
            <el-select
              v-model="queryParams.crease"
              filterable
              placeholder="活动分类"
              clearable
              size="small"
              style="width: 160px"
            >
              <el-option
                v-for="dict in types"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="发奖原因" prop="action">-->
          <!--            <el-select-->
          <!--              v-model="queryParams.rid"-->
          <!--              placeholder="请选择发奖原因"-->
          <!--              clearable-->
          <!--              size="small"-->
          <!--              @keyup.enter.native="handleQuery"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                v-for="(item, index) in ridType"-->
          <!--                :key="index"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="奖励类型" prop="type">-->
          <!--            <el-select-->
          <!--              v-model.number="queryParams.type"-->
          <!--              placeholder="请选择类型"-->
          <!--              clearable-->
          <!--              size="small"-->
          <!--              @keyup.enter.native="handleQuery"-->
          <!--            >-->
          <!--              <el-option-->
          <!--                v-for="(item, index) in rewardType"-->
          <!--                :key="index"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            width="200"
          />
          <el-table-column
            prop="typeName"
            label="活动"
            width="200"
          />
          <el-table-column
            prop="num"
            label="进度"
            width="200"
          />
          <el-table-column
            prop="crease"
            label="类型"
            width="200"
          />
          <el-table-column
            prop="reason"
            label="原因"
            width="350"
          />
          <el-table-column
            prop="time1"
            label="变化时间"
          />
          <el-table-column
            prop="last_num"
            label="最终进度"
          />
          <!--          <el-table-column-->
          <!--            prop="记录ID"-->
          <!--            label="结束积分"-->
          <!--          />-->
          <!--          <el-table-column-->
          <!--            prop="game_version"-->
          <!--            label="游戏版本"-->
          <!--          />-->
        </el-table>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActRewardRecordList, getRidTypeList } from '@/api/config/reward-record'
import { getRewardType } from '@/api/config/slot'
import { getActivityTypesList } from '@/api/config/activity-cfg'
export default {
  name: 'ActRewardRecord',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        uid: '',
        time: '',
        rid: '',
        type: '',
        crease: ''
      },
      types: [],
      total: 0,
      tableData: [
        {
          'uid': 0,
          'type': '',
          'num': '',
          'crease': '',
          'reason': 0,
          'time': 0,
          'last_num': 0,
          'score_end': 0,
          'rid': 1,
          'levelId': 0
        }
      ],
      rewardType: [],
      ridType: []
    }
  },
  created() {
    this.getActivityTypes()
    this.getRidTypeData()
    this.getRewardTypeData()
    this.getTables()
  },
  methods: {
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.time === '') {
        this.msgError('请选择日期')
        return
      }
      this.getTables()
    },
    getActivityTypes() {
      getActivityTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.types.push({ label: val, value: i })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getRidTypeData() {
      getRidTypeList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.ridType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    getTables() {
      getActRewardRecordList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list.data
          this.total = res.data.count
          this.queryParams.time = res.data.list.req.Time
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
